import { useTranslation } from "react-i18next";
import { pencilIcon } from "../../assets/svgs/icons/icons.svg";
import { useCollaborteurStore } from "../../stores/collaborateur/collaborateur.store";
import { formatPhoneNumber } from "../../utils";
import InformationSection from "../InformationSection/InformationSection";
import Button from "../global/Button/Button";

import styles from "./InscriptionRecapInfoPersonnelles.module.scss";

type Props = {
  setIsOpenModificationPopup?: React.Dispatch<React.SetStateAction<boolean>>;
  hasModifierButton: boolean;
};
export default function InscriptionRecapInfoPersonnelles(props: Props) {
  const { setIsOpenModificationPopup, hasModifierButton } = props;
  const { selectedCollaborateur } = useCollaborteurStore();
  const { t } = useTranslation();

  function onClickModifier() {
    setIsOpenModificationPopup && setIsOpenModificationPopup(true);
  }
  return (
    <article
      className={styles.inscriptionRecap}
      is-recap-page={hasModifierButton ? "yes" : "no"}
    >
      <article className={styles.inscriptionRecap__InfoPersonnelles}>
        <header className={styles.inscriptionRecap__InfoPersonnelles__header}>
          <h2>{t("collaborateur.personalInfo")}</h2>
          {hasModifierButton && (
            <Button
              text={t("common.modify")}
              buttonBackGroundColor="white"
              textColor="dark"
              icon={pencilIcon}
              onClick={onClickModifier}
            />
          )}
        </header>
        <main className={styles.inscriptionRecap__InfoPersonnelles__main}>
          <section
            className={styles.inscriptionRecap__InfoPersonnelles__civilite}
          >
            <InformationSection
              label={t("collaborateur.civilite")}
              text={selectedCollaborateur?.civilite || "-"}
            />
          </section>

          <section
            className={styles.inscriptionRecap__InfoPersonnelles__mainInfos}
          >
            <section>
              <InformationSection
                label={t("collaborateur.uppercase.nom")}
                text={selectedCollaborateur?.nom || "-"}
              />
              <InformationSection
                label={t("collaborateur.email")}
                text={selectedCollaborateur?.email || "-"}
              />
              <InformationSection
                label={t("collaborateur.fonction")}
                text={selectedCollaborateur?.fonction || "-"}
              />
            </section>
            <section>
              <InformationSection
                label={t("collaborateur.prenom")}
                text={selectedCollaborateur?.prenom || "-"}
              />
              <InformationSection
                label={t("collaborateur.telephone")}
                text={formatPhoneNumber(selectedCollaborateur?.phone)}
              />
              <InformationSection
                label={t("collaborateur.service")}
                text={selectedCollaborateur?.direction || "-"}
              />
            </section>
          </section>
        </main>
      </article>
      <article className={styles.inscriptionRecap__droitImage}>
        <header className={styles.inscriptionRecap__droitImage__header}>
          <h2>{t("inscriptionDroitImage.title")}</h2>
        </header>
        <main className={styles.inscriptionRecap__droitImage__main}>
          <section className={styles.inscriptionRecap__droitImage__main__text}>
            <p>
              {t("inscriptionDroitImage.description1")}
            </p>
            <p>
              {t("inscriptionDroitImage.description2")}
            </p>
          </section>
          <section
            className={styles.inscriptionRecap__droitImage__main__radioButtons}
          >
            <label>
              <input
                id="droitImage_recap_radio_button_true"
                type="radio"
                name="droitImage_recap_radio_button_true"
                value="true"
                readOnly
                checked={selectedCollaborateur?.hasDroitImage}
              />
              {t("common.yes")}
            </label>
            <label>
              <input
                id="droitImage_inscirption_radio_button_false"
                type="radio"
                name="droitImage_recap_radio_button_true"
                value="false"
                readOnly
                checked={!selectedCollaborateur?.hasDroitImage}
              />
              {t("common.no")}
            </label>
          </section>
        </main>
      </article>
    </article>
  );
}
